module.exports = __webpack_public_path__ + "img/Enklare-1024x279.fa677adb.png";